import { useTranslation } from "react-i18next";
import { Wrench } from "lucide-react";
import { hasAnyMock, listActiveMocks } from "@/lib/mock-flags";

export function MockBanner() {
  const { t } = useTranslation();
  if (!hasAnyMock()) return null;

  const modules = listActiveMocks();
  const shown = modules.slice(0, 5).join(", ");
  const more = modules.length > 5 ? ` +${modules.length - 5}` : "";

  return (
    <div className="flex items-center justify-center gap-2 border-b border-warning-soft bg-warning-soft/60 px-4 py-1.5 text-[12px] font-medium text-warning-ink">
      <Wrench size={13} />
      <span>{t("mock.banner", { modules: shown + more })}</span>
    </div>
  );
}
